"use client"

import {
  Badge,
  Divider,
  LogoutButton,
  NavigationItem,
} from "@/components/atoms"
import { Dropdown } from "@/components/molecules"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { ProfileIcon } from "@/icons"
import { HttpTypes } from "@medusajs/types"
import { useUnreads } from "@talkjs/react"
import { useState } from "react"

export const UserDropdown = ({
  isLoggedIn,
  name,
  firstName,
}: {
  isLoggedIn: boolean
  /** الاسم الكامل (أو البريد إن لم يُسجَّل اسم) — رأس القائمة */
  name?: string | null
  /** الاسم الأول — بجانب الأيقونة في الترويسة */
  firstName?: string | null
}) => {
  const [open, setOpen] = useState(false)

  const unreads = useUnreads()

  return (
    <div
      className="relative"
      onMouseOver={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
    >
      <LocalizedClientLink
        href={isLoggedIn ? "/user" : "/login"}
        className="relative flex items-center gap-1.5"
        aria-label="حسابي"
      >
        <ProfileIcon size={20} />
        {isLoggedIn && (firstName || name) && (
          <span className="hidden max-w-[8rem] truncate text-sm font-medium text-white sm:inline">
            {firstName || name}
          </span>
        )}
      </LocalizedClientLink>
      <Dropdown show={open}>
        {isLoggedIn ? (
          <div className="p-1">
            <div className="lg:w-[200px]">
              <div className="border-b p-4">
                <p className="label-sm text-secondary">مرحباً</p>
                <h3 className="heading-xs truncate">{name || "حسابي"}</h3>
              </div>
            </div>
            <NavigationItem href="/user/orders">طلباتي</NavigationItem>
            {/* <NavigationItem href="/user/messages" className="relative">
              Messages
              {Boolean(unreads?.length) && (
                <Badge className="absolute top-3 left-24 w-4 h-4 p-0">
                  {unreads?.length}
                </Badge>
              )}
            </NavigationItem>
            <NavigationItem href="/user/returns">Returns</NavigationItem> */}
            <NavigationItem href="/user/addresses">العناوين</NavigationItem>
            <Divider />
            <NavigationItem href="/user/settings">الإعدادات</NavigationItem>
            <LogoutButton>تسجيل الخروج</LogoutButton>
          </div>
        ) : (
          <div className="p-1">
            <NavigationItem href="/login">دخول</NavigationItem>
            <NavigationItem href="/register">حساب جديد</NavigationItem>
          </div>
        )}
      </Dropdown>
    </div>
  )
}
